import * as Immutable from 'immutable';
import ModuleStore from '../../Module/_stores/ModuleStore';

export interface IModuleListStore {
	modules: Immutable.OrderedMap<string, ModuleStore>
	selectedModuleId: string
}

const defaultStore = Immutable.Record<IModuleListStore>({
	modules: Immutable.OrderedMap<string, ModuleStore>(),
	selectedModuleId: undefined,
});

export default class ModuleListStore extends defaultStore implements IModuleListStore {}